<template>
  <div>Генерация документов</div>
</template>

<script>
export default {
  name: 'ClinicPanelDocumentGenerations',
};
</script>

<style>

</style>
